import { render, staticRenderFns } from "./Kupon.vue?vue&type=template&id=97c5a46a&"
import script from "./Kupon.vue?vue&type=script&lang=js&"
export * from "./Kupon.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports